import { applyCustomTheme, CustomThemeSet } from '@vimeo/bifrost/themes';
import { grayscale, slate, white } from '@vimeo/iris/color';

interface CustomTheme {
  elements: {
    bg0: string;
    bg1: string;
    color0: string;
    color1: string;
    color2: string;
    color3: string;
    color4: string;
    color5: string;
    color6: string;
  };
  icons: {
    fill0: string;
  };
}

export const customThemes: CustomThemeSet<CustomTheme> = {
  light: {
    elements: {
      bg0: slate(50),
      bg1: white,
      color0: slate(100),
      color1: slate(200),
      color2: slate(800),
      color3: slate(800),
      color4: slate(200),
      color5: slate(300),
      color6: slate(100),
    },
    icons: {
      fill0: grayscale(250),
    },
  },
  dark: {
    elements: {
      bg0: grayscale(700),
      bg1: grayscale(800),
      color0: grayscale(600),
      color1: grayscale(400),
      color2: grayscale(100),
      color3: white,
      color4: grayscale(600),
      color5: grayscale(200),
      color6: grayscale(730),
    },
    icons: {
      fill0: grayscale(200),
    },
  },
};

export const applyCustomThemeEssentialFooter = applyCustomTheme(customThemes);
